<template>
	<div>
		<el-input
			placeholder="输入关键字进行过滤"
			v-model="filterText">
		</el-input>
		<el-tree
		  :data="dataSource"
		  show-checkbox
		  node-key="id"
		  :expand-on-click-node="false"
		  :filter-node-method="filterNode"
		  style="border:1px solid #eee; margin-top:10px; margin-right:2px; height:400px; overflow-y:scroll"
		  ref = "tree"
		>
			<template #default="{ node, data }">
				<span class="custom-tree-node">
					<span>{{ data.title }}</span>
				</span>
			</template>
		</el-tree>
		<el-checkbox v-model="checkedAll" @change = "checkAll" style="margin-top:5px">全选</el-checkbox>
		<el-link type="primary" @click="setDefault" style="margin-left:10px;margin-top:-4px">还原为默认值</el-link>
	</div>
</template>

<script>
export default {
    name: 'AuthoritySet',
    data() {
        return {
			dataSource:[],
			filterText:"",
			checkedAll:false,
			checkedKeys:[]
        };
    },
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		}
    },
    methods: {
		//节点过滤
		filterNode(value, data) {
			if (!value) return true;
			return data.title.indexOf(value) !== -1;
		},
		setDatasource(data, checkedKeys, showKeys) {
			if (showKeys == undefined) {
				this.dataSource = data;
			} else {
				let nodeStr = JSON.stringify(data);
				let nodes = JSON.parse(nodeStr);
				this.builSelectTree(nodes, showKeys);
				this.dataSource = nodes;
			}
			this.checkedKeys=checkedKeys;
			this.$refs.tree.setCheckedKeys(checkedKeys);
			this.checkedAll = false;
			
		},
		getCheckedKeys() {
			return this.$refs.tree.getCheckedKeys();
		},
		getCheckedNodes() {
			let checkedKeys = this.$refs.tree.getCheckedKeys();
			let nodeStr = JSON.stringify(this.dataSource);
			let nodes = JSON.parse(nodeStr);
			this.builSelectTree(nodes, checkedKeys);
			return nodes;
		},
		//数据源递归，
		//如果末尾节点没有选中，则删除，
		//当一个节点下末尾节点都删除了，当前节点也删除
		builSelectTree(nodes, checkedKeys) {
			for(var i = nodes.length - 1; i >= 0; i--) {
				if (nodes[i].children.length > 0) {
					//节点有子节点，继续递归
					this.builSelectTree(nodes[i].children, checkedKeys);
					//递归后，当前节点没有子节点，则删除当前节点
					if (nodes[i].children.length == 0) {
						nodes.splice(i, 1);
					}
				} else {
					//末尾节点，则判断节点key是否在选中节点之中，没有则删除
					if (checkedKeys.indexOf(nodes[i].id) == -1) {
						nodes.splice(i, 1);
					}
				}
			}
		},
		checkAll() {
			if (this.checkedAll) {
				this.$refs.tree.setCheckedNodes(this.dataSource);
			} else {
				this.$refs.tree.setCheckedKeys([]);
			}
		},
		setDefault() {
			this.$refs.tree.setCheckedKeys(this.checkedKeys);
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.edit-container {
  height: 570px;
  padding: 10px 20px;
}

.edit {
  display: flex;
  height: 530px;
}

.leftBox {
  width: 45px;
  height: 100%;
  text-align: left;
}

.area-content {
  padding: 10px 8px;
  width: 100%;
  height: 100%;
  font-size: 13px;
  line-height: 24px;
  color: #2dc26b;
  font-family: Consolas;
  border: none;
  background: #373737;
  box-sizing: border-box;
  outline: none;
  resize: none;
}

#leftNum {
  padding: 10px 4px;
  height: 100%;
  width: 100%;
  line-height: 24px;
  font-size: 13px;
  text-align: right;
  color: #fff;
  font-weight: bold;
  resize: none;
  outline: none;
  border: 0;
  background: black;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.spiltBar:hover{ 
	filter:alpha(Opacity=100);
	-moz-opacity:1;
	opacity:1;
}

.spiltBar{
	height:600px;
	width:10px;
	position:absolute;
	margin-left:-15px;
	text-align:center;
	line-height:600px;
	cursor: pointer;
	filter:alpha(Opacity=60);
	-moz-opacity:0.6;
	opacity:0.6;
}
</style>
